import React from 'react';
import { LayoutStatic } from 'components/ui/layoutStatic';
import { Video } from 'components/video';

export const StaticPageVideo = () => (
    <LayoutStatic>
        <Video/>
    </LayoutStatic>
);
